const initialState = {
   isFetching: false,
   hasBeenSent: false,
   error: {},
};

export default initialState;
